import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Link from 'gatsby-link';
import { theme } from 'styles';

const { colors } = theme;

const Wrapper = styled.div``;

const StyledLink = styled(Link)`
  text-decoration: none;
  color: ${props => (props.light ? colors.white : colors.black)};
  font-size: 14px;

  &::after {
    display: inline-block;
    padding: 0 4px;
    content: '/';
  }

  &:last-child {
    opacity: ${props => (props.light ? '0.7' : '1')};
    color: ${props => (props.light ? colors.white : colors.blue)};
    &::after {
      display: none;
    }
  }
`;

function Breadcrumbs({ breadcrumbs, left, light }) {
  return (
    <Wrapper left={left}>
      {breadcrumbs &&
        breadcrumbs.map(crumb => (
          <StyledLink key={crumb.name} light={light} to={crumb.link}>
            {crumb.name}
          </StyledLink>
        ))}
    </Wrapper>
  );
}

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.arrayOf(PropTypes.object).isRequired,
  left: PropTypes.bool.isRequired,
  light: PropTypes.bool,
};
Breadcrumbs.defaultProps = {
  light: false,
};

export default Breadcrumbs;



// WEBPACK FOOTER //
// ./src/components/shared/Breadcrumbs/Breadcrumbs.jsx